mutation StopTugOfWar($tugId: ID!) {
  tug: StreamToolsStopTugOfWar(tugId: $tugId) {
    tugId
    status
    youtubeVotesEnabled
    stoppedAt
    graceEndsAt
  }
}
